/* eslint-disable global-require */
export const logoboxImage = require('../assets/images/logo-box.svg');
export const backIcon = require('../assets/images/back_btn.svg');
export const logoImage = require('../assets/images/ebb-logo.svg');
export const facebookIcon = require('../assets/images/facebook.svg');
export const googleIcon = require('../assets/images/google.svg');
export const passwordEyeShow = require('../assets/images/password-eye-show.svg');
export const passwordEyeHide = require('../assets/images/password-eye-hide.svg');
export const successMessageIcon = require('../assets/images/success-message.svg');
export const loginLineImage = require('../assets/images/login_line.svg');
export const femaleActiveIcon = require('../assets/images/female-active.svg');
export const femaleInActiveIcon = require('../assets/images/female-inactive.svg');

export const maleActiveIcon = require('../assets/images/male-active.svg');
export const maleInActiveIcon = require('../assets/images/male-inactive.svg');

export const editProfileIcon = require('../assets/images/edit-profile.svg');
export const selectPosterIcon = require('../assets/images/poster-selection.svg');
export const closeIcon = require('../assets/images/close-icon.svg');
export const switchProfileIcon = require('../assets/images/switch-profile.svg');
export const myFavouritesIcon = require('../assets/images/my-favourites.svg');
export const preferencesIcon = require('../assets/images/preferences.svg');
export const logOutIcon = require('../assets/images/logOut.svg');
export const historyIcon = require('../assets/images/historyIcon.svg');
export const subscriptionIcon = require('../assets/images/subscription.svg');

export const accountIcon = require('../assets/images/account.svg');
export const feedbackIcon = require('../assets/images/feedback.svg');
export const SupportIcon = require('../assets/images/helpAnd Support.svg');
export const languageIcon = require('../assets/images/language.svg');
export const settingsIcon = require('../assets/images/settings.svg');
export const parentBigAvatarIcon = require('../assets/images/avatar/big_avatar_1.png');
export const parentAvatarIcon = require('../assets/images/avatar/avatar2.png');

export const poster1 = require('../assets/images/poster/poster_1.png');
export const poster2 = require('../assets/images/poster/poster_2.png');
export const poster3 = require('../assets/images/poster/poster_3.png');
export const poster4 = require('../assets/images/poster/poster_4.png');
export const poster5 = require('../assets/images/poster/poster_5.png');
export const avatarProfileFinish = require('../assets/images/avatar/avatar_profile_finish.png');
export const fireWork = require('../assets/images/fireWork.svg');
export const removeAccountIcon = require('../assets/images/remove-account.svg');
export const bbLogo = require('../assets/images/home/bb-logo.svg');
export const explore = require('../assets/images/home/explore.svg');
export const background = require('../assets/images/home/home-bg.svg');
export const languages = require('../assets/images/home/Languages.svg');
export const login = require('../assets/images/home/login.svg');
export const movies = require('../assets/images/home/movies.svg');
export const myBBImgOne = require('../assets/images/home/mybb-img1.svg');
export const myBBImgTwo = require('../assets/images/home/mybb-img2.svg');
export const notification = require('../assets/images/home/notification.svg');
export const search = require('../assets/images/home/search.svg');
export const shows = require('../assets/images/home/shows.svg');
export const leftArrow = require('../assets/images/arrow_left_btn.svg');
export const rightArrow = require('../assets/images/arrow_right_btn.svg');

export const playIcon = require('../assets/images/playIcon.svg');
export const languageAvatarIcon = require('../assets/images/Languages-asset1.svg');

export const tvShows = require('../assets/images/home/tvshows-img1.svg');
export const starsSmall = require('../assets/images/home/tv-show-asset1.svg');
export const starsBig = require('../assets/images/home/tv-show-asset2.svg');
export const tvShowsImg = require('../assets/images/home/tv-show-img1.png');
export const homeMoviesStarIcon = require('../assets/images/movies-stars.svg');
export const homeMoviesPashuIcon = require('../assets/images/movies-pashu.svg');

export const mybbAsset1 = require('../assets/images/myBBPosters/artsCrafts.png');
export const mybbAsset2 = require('../assets/images/myBBPosters/games.png');
export const mybbAsset3 = require('../assets/images/myBBPosters/shopping.png');

export const footerBg = require('../assets/images/footer-bg.svg');
export const footerElephantIcon = require('../assets/images/footer-asset1.svg');
export const facebookFooterIcon = require('../assets/images/facebook-footer.svg');
export const googleFooterIcon = require('../assets/images/google-footer.svg');
export const twitterIcon = require('../assets/images/twitter.svg');
export const youtubeIcon = require('../assets/images/youtube.svg');
export const parentProfileSample = require('../assets/images/parentProfileSample.png');

export const langDownArrow = require('../assets/images/down-arrow.svg');
export const searchIcon = require('../assets/images/search-header.svg');
export const avatarHeader = require('../assets/images/avatar-header.svg');
export const homeHeader = require('../assets/images/home-header.svg');
export const showsHeader = require('../assets/images/tvshows-header.svg');
export const showsSelected = require('../assets/images/tvshows-selected.svg');
export const moviesHeader = require('../assets/images/movies-header.svg');
export const moviesSelected = require('../assets/images/movies-selected.svg');
export const myBBHeader = require('../assets/images/mybb-header.svg');
export const ellipseWhite = require('../assets/images/ellipse-white.svg');

export const tvShowsHomeOriginals1 = require('../assets/images/tvShows/TS-asset1.svg');
export const tvShowsHomeOriginals2 = require('../assets/images/tvShows/viewall.svg');
export const tvShowsHomeOriginals3 = require('../assets/images/tvShows/tv-show-img1.png');
export const tvShowsToddlers1 = require('../assets/images/tvShows/TS-asset2.svg');
export const tvShowsToddlers2 = require('../assets/images/tvShows/TS-asset3.svg');
export const tvShowsHomeEdutainment1 = require('../assets/images/tvShows/TS-asset5.svg');
export const tvShowsHomeGlobal = require('../assets/images/tvShows/TS-asset4.svg');
export const watchNowBtn = require('../assets/images/watch-now-button.svg');

export const originalsBanner = require('../assets/images/tvshows-originals-banner.png');
export const originalsIcon = require('../assets/images/tvshows-originals-icon.svg');
export const globalBanner = require('../assets/images/tvshows-global-banner.png');
export const globalIcon = require('../assets/images/tvshows-global-icon.svg');
export const toddlersBanner = require('../assets/images/tvshows-toddlers-banner.png');
export const toddlersIcon = require('../assets/images/tvshows-toddlers-icon.svg');
export const edutainmentBanner = require('../assets/images/tvshows-edutainment-banner.png');
export const edutainmentIcon = require('../assets/images/tvshows-edutainment-icon.svg');
export const adBannerIconTwo = require('../assets/images/TS-asset7.svg');
export const adBannerIconThree = require('../assets/images/play2.svg');
export const adBannerIconFour = require('../assets/images/tv-show-bg1.jpg');
export const shareIcon = require('../assets/images/share-icon.svg');
export const sampleImage = require('../assets/images/img222.jpg');
export const favouriteIcon = require('../assets/images/favorite.svg');
export const tplayIcon = require('../assets/images/tplayIcon.svg');
export const janeRemovebg = require('../assets/images/Jane_removebg.svg');
export const mobileHomeBackground = require('../assets/images/m-home-bg.svg');
export const janeRight = require('../assets/images/jane-right.svg');

export const searchClose = require('../assets/images/search_close.svg');
export const emptySearchResultsIcon = require('../assets/images/empty_search_results_icon.svg');
export const comingSoon = require('../assets/images/comingSoon.png');
export const searchIconWhite = require('../assets/images/searchIconWhite.svg');
export const mshows = require('../assets/images/m-tvshows.svg');
export const mmovies = require('../assets/images/m-movies.svg');
export const mmybb = require('../assets/images/m-mybb.svg');
export const mtopbg = require('../assets/images/m-top-bg.svg');
export const toggleMenu = require('../assets/images/toggle-menu.svg');
export const mfooterBg = require('../assets/images/m-footer-bg.svg');
export const mfooterAssetOne = require('../assets/images/footer-asset1.svg');
export const mOriginalsBanner = require('../assets/images/m-tv-shows-banner.svg');
export const mToddlersBanner = require('../assets/images/mToddlersBanner.svg');
export const mGloablBanner = require('../assets/images/mGlobalBanner.svg');
export const mEdutainmentBanner = require('../assets/images/mEdutainmentBanner.svg');
export const mTvshowsBackBtn = require('../assets/images/tvShows-back.svg');
export const moviesAssetOne = require('../assets/images/movies-asset1.svg');
export const favouriteUnselect = require('../assets/images/favourite-unselect.svg');
export const favouriteSelect = require('../assets/images/favourite-select.svg');
export const playerBackBtn = require('../assets/images/player_back_btn.svg');
export const notificationContent = require('../assets/images/temp/notifications.png');
export const myFavourites = require('../assets/images/temp/myFavouritesList.svg');
export const menuIconOne = require('../assets/images/temp/menuIconOne.svg');
export const addNew = require('../assets/images/addNew.svg');
export const Phone = require('../assets/images/VectorPhone.svg');
export const Mail = require('../assets/images/VectorMail.svg');
export const Location = require('../assets/images/VectorLocation.svg');
export const upArrow = require('../assets/images/upArrow.svg');
export const downArrow = require('../assets/images/downArrow.svg');
export const settingsLogo = require('../assets/images/settings/settingsLogo.svg');
export const settingsMusic = require('../assets/images/settings/settingsMusic.svg');
export const settingsNotifications = require('../assets/images/settings/settingsNotifications.svg');
export const settingsParental = require('../assets/images/settings/settingsParental.svg');
export const settingsStar = require('../assets/images/settings/settingsStar.svg');
export const notificationBell = require('../assets/images/notification_bell.svg');
export const watchHistoryIcon = require('../assets/images/watchHistory.svg');
export const calendarIcon = require('../assets/images/calendar-icon.svg');
export const watchHistory = require('../assets/images/watchHistory.svg');
export const mapMarker = require('../assets/images/marker.png');
export const newHomePageEventIcon = require ('../assets/images/event/events icon.png');
export const newHomePageRAEAIcon = require('../assets/images/raea/RAEA-icon.png');
export const newHomePageHTvShows = require('../assets/images/home/new/tvshows.svg');
export const newHomePageMovies = require('../assets/images/home/new/movies.svg');
export const newHomePageMyBb = require('../assets/images/home/new/mybb.svg');
export const newHomePageSearch = require('../assets/images/home/new/search.svg');
export const newHomePageGirlPic = require('../assets/images/home/new/hi.png');
export const newHomeLogo = require('../assets/images/home/new/logo.png');
export const newHomeLoginIcon = require('../assets/images/home/new/login.svg');
export const yellowLeftArrow = require('../assets/images/home/new/left-arrow.svg');
export const yellowRightArrow = require('../assets/images/home/new/right-arrow.svg');
export const viewAll = require('../assets/images/home/new/viewall.svg');

// API Related Images
export const apiBannerImage = require('../assets/images/home/new/banner.png');
export const apiToon = require('../assets/images/home/new/p-pic.png');
export const cardPic = require('../assets/images/home/new/img1.jpg');
export const logo = require('../assets/images/logo.png');
// header imgs
export const HiImg = require('../assets/images/hi.png');
export const HiImgNew = require('../assets/images/MascotNew.png');
export const tvshowsIcon = require('../assets/images/tvshows.svg');
export const moviesIcon = require('../assets/images/movies.svg');
export const mybbIcon = require('../assets/images/mybb.svg');
export const searchToIcon = require('../assets/images/search.svg');
export const notificationBellWhite = require('../assets/images/notification-white.svg');
export const ResponsiveHomeIcon = require('../assets/images/BottomHome.svg');
export const ResponsiveMoveIcon = require('../assets/images/bottomMovies.svg');
export const ResponsiveTvIcon = require('../assets/images/bottomTv.svg');
export const ResponsiveSearchIcon = require('../assets/images/bottomSearch.svg');
export const ResponsiveLogo = require('../assets/images/logo_mobile.svg');


// toons detail
export const favIcon = require('../assets/images/favourite.svg');
export const tplayYellowIcon = require('../assets/images/play-yellow.svg');
export const toonBg = require('../assets/images/tone-bg.svg');
export const show1 = require('../assets/images/toonDetail/show1.png');
export const show2 = require('../assets/images/toonDetail/show2.png');
export const show3 = require('../assets/images/toonDetail/show3.png');
export const show4 = require('../assets/images/toonDetail/show4.png');
export const show5 = require('../assets/images/toonDetail/show5.png');
export const toon1 = require('../assets/images/toonDetail/toon1.png');
export const toon2 = require('../assets/images/toonDetail/toon2.png');
export const toon3 = require('../assets/images/toonDetail/toon3.png');
export const toon4 = require('../assets/images/toonDetail/toon4.png');
// mybb
export const eventbg = require('../assets/images/myBBPosters/event-bg.png');
export const location = require('../assets/images/location-icon.svg');
export const rightArrowBtn = require('../assets/images/arrow-right.svg');
export const topArrowBtn = require('../assets/images/arrow-top.svg');
// language
export const selectionOne = require('../assets/images/language/selection-bg-1.svg');
export const selectionTwo = require('../assets/images/language/selection-bg-2.svg');
export const selectionThree = require('../assets/images/language/selection-bg-3.svg');
// about us
export const aboutBG = require('../assets/images/aboutusbg.png');
export const mainVTImg = require('../assets/images/aboutUs/main-vt.png');
export const VT1 = require('../assets/images/aboutUs/vt-1.png');
export const VT2 = require('../assets/images/aboutUs/vt-2.png');

export const aboutInActive = require('../assets/images/AboutUsInactive.svg');
export const aboutActive = require('../assets/images/AboutUsActive.svg');
export const FooterInstagram = require('../assets/images/Instagram.svg');
export const defaultLogo = require('../assets/images/ETV_ENGLISH_NET.png');
export const logoBackground = require('../assets/images/logo-bg.svg');

// channelschedule
export const chbgleft = require('../assets/images/channelschedule/bgassetleft.png');
export const chbgright = require('../assets/images/channelschedule/bgassetsright.png');
export const chimgone = require('../assets/images/channelschedule/channelimgone.png');
export const chimgtwo = require('../assets/images/channelschedule/channelimgtwo.png');
export const chimgthree = require('../assets/images/channelschedule/channelimgthree.png');

// coming Soon
export const comming = require('../assets/images/commingsoon/coming.png');
export const soon = require('../assets/images/commingsoon/Comingsoon_movies_new.png');
export const aboutvideo = require('../assets/images/commingsoon/aboutvideo.png');

// channel selection images
export const assam = require('../assets/images/channelSongThumbnail/ChannelSong.Assames.jpg');
export const bangla = require('../assets/images/channelSongThumbnail/ChannelSong.Bangla.jpg');
export const english = require('../assets/images/channelSongThumbnail/ChannelSong.English.jpg');
export const gujarati = require('../assets/images/channelSongThumbnail/ChannelSong.Gujarati.jpg');
export const hindi = require('../assets/images/channelSongThumbnail/ChannelSong.Hindi.jpg');
export const kannda = require('../assets/images/channelSongThumbnail/ChannelSong.Kannda.jpg');
export const malyalam = require('../assets/images/channelSongThumbnail/ChannelSong.Malyalam.jpg');
export const marathi = require('../assets/images/channelSongThumbnail/ChannelSong.Marathi.jpg');
export const odia = require('../assets/images/channelSongThumbnail/ChannelSong.Odia.jpg');
export const punjabi = require('../assets/images/channelSongThumbnail/ChannelSong.Punjabi.jpg');
export const tamil = require('../assets/images/channelSongThumbnail/ChannelSong.Tamil.jpg');
export const telgu = require('../assets/images/channelSongThumbnail/ChannelSong.Telgu.jpg');

//raea images 
export const raraweblogo = require('../assets/images/raea/RAEA-WEB-Logo.png');
 
// event page releted images 
export const nextbutton = require('../assets/images/event/btn-next.png')
export const paintathon = require('../assets/images/event/paintathon-bg.jpg');
export const nextpage = require('../assets/images/event/paintathon-next-p.jpg');
export const buttonImg = require ('../assets/images/event/conan-ban-btn.png');
export const groupImage1 = require ('../assets/images/event/1.jpg');
export const winnerImage_4 = require ('../assets/images/event/2.jpg');
export const winnerImage_2= require ('../assets/images/event/3.jpg');
export const groupImage_3 = require ('../assets/images/event/4.jpg');
export const winnerImage = require ('../assets/images/event/5.jpg');
export const  groupImage_2= require ('../assets/images/event/6.jpg');
export const  volumeIcon  = require ('../assets/images/event/volume_icon.png')
export const  muteIcon  = require ('../assets/images/event/mute_icon.png')
export const mobWinner  = require ('../assets/images/event/winner-list-bg.png');

// CanonEvent regarding 

export const conan = require('../assets/images/event/conan-bg.jpg');
export const conanyear = require('../assets/images/event/conan-yr-bg.jpg');
export const conanWinList = require('../assets/images/event/conan-win-list.jpg');
export const conanbtn = require('../assets/images/event/conan-ban-btn.png');
export const conanwin = require('../assets/images/event/conan-win-list.jpg');
export const mob_Painthon =require('../assets/images/event/mob-paintathon-main.jpg');
export const mob_Conan = require('../assets/images/event/mob-conan-main.jpg');
export const mob_nextPage = require('../assets/images/event/mob-paintathon-dppage.png');
export const mob_nextButton = require('../assets/images/event/mob-btn-next.png');
export const mob_conan_bg =require ('../assets/images/event/mob-conan-bg.jpg');
export const mob_paintathonList = require('../assets/images/event/mob-paintathon-list-pg01.png');
export const mob_paintathon_2021 = require ('../assets/images/event/paintathon-2021.png');
export const mob_paintathon_2022 = require ('../assets/images/event/paintathon-2022.png');
export const mob_paintathon_2024 = require ('../assets/images/event/paintathon-2024.png');
export const mob_pain_winner = require ('../assets/images/event/mob-pain-winner-bg.png');
export const mob_winnerboard = require ('../assets/images/event/mob-pain-withoutpink-bg.png');
export const mob_conan_Win_List = require ('../assets/images/event/mob-conan-windetails.jpg');
export const mob_win_23 = require ('../assets/images/event/mon-win-23.png');
export const mob_win_24 = require ('../assets/images/event/winner-board.png');
export const mega_winner_24 = require('../assets/images/event/07.jpg');
export const paintathonList = require('../assets/images/event/mob-paintathon-list-pg01.png');
export const paintathon_2021 = require ('../assets/images/event/paintathon-2021.png');
export const paintathon_2022 = require ('../assets/images/event/paintathon-2022.png');
export const paintathon_2024 = require ('../assets/images/event/paintathon-2024.png');
export const pain_winner = require ('../assets/images/event/mob-pain-winner-bg.png');
export const close = require('../assets/images/event/mob-close-btn.png');
export  const paintbrush = require('../assets/images/event/paintbrush.png');

